// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat
class I18nListFormatter {
    #locale;

    #listFormatter;

    #unitListFormatter;

    constructor (locale = 'en') {
        this.initializeFormatter(locale);
    }

    initializeFormatter (locale) {
        this.#locale = locale;
        this.#listFormatter = new Intl.ListFormat(locale);
        this.#unitListFormatter = new Intl.ListFormat(locale, { type: 'unit' });
    }

    get locale () {
        return this.#locale;
    }

    set locale (newLocale) {
        this.initializeFormatter(newLocale);
    }

    // i18n-friendly list formatting
    // [A, B, C] -> A, B, and C
    formatList (list) {
        return this.#listFormatter.format(list);
    }

    // i18n-friendly unit list formatting
    // [A, B, C] -> A, B, C
    formatUnitList (list) {
        return this.#unitListFormatter.format(list);
    }
}

const i18nListFormatter = new I18nListFormatter();

export default i18nListFormatter;
